import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, MessageCircle, MonitorOff, ShieldAlert, ListChecks, CalendarDays } from 'lucide-react';
export function DeliverablesSection() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-[#6B9E7A]" data-id="element-22" />,
    title: 'Guía PDF de 10 páginas',
    desc: 'Con el plan exacto día por día.'
  }, {
    icon: <MessageCircle className="w-6 h-6 text-[#6B9E7A]" data-id="element-23" />,
    title: 'El Diccionario de la Orden Corta',
    desc: 'Frases de 3 palabras que sí funcionan.'
  }, {
    icon: <MonitorOff className="w-6 h-6 text-[#6B9E7A]" data-id="element-24" />,
    title: 'Técnica de Transiciones',
    desc: 'Cómo apagar pantallas sin que el mundo se acabe.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-[#6B9E7A]" data-id="element-25" />,
    title: 'El Semáforo de la Calma',
    desc: 'Qué hacer tú cuando sientes que vas a explotar.'
  }, {
    icon: <ListChecks className="w-6 h-6 text-[#6B9E7A]" data-id="element-26" />,
    title: 'Hoja de Consecuencias Lógicas',
    desc: 'Qué hacer cuando dicen "NO" (sin usar castigos).'
  }, {
    icon: <CalendarDays className="w-6 h-6 text-[#6B9E7A]" data-id="element-27" />,
    title: 'Tracker Imprimible de 7 días',
    desc: 'Para medir el progreso real en casa.'
  }];
  return <section className="py-20 px-4 max-w-6xl mx-auto" data-id="element-28">
      <FadeIn data-id="element-29">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-[#2D2A26] mb-12" data-id="element-30">
          ¿Qué vas a recibir hoy?
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-31">
        {deliverables.map((item, index) => <FadeIn key={index} delay={index * 100} data-id="element-32">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#2D2A26]/5 h-full flex flex-col hover:shadow-md transition-shadow" data-id="element-33">
              <div className="w-12 h-12 rounded-full bg-[#6B9E7A]/10 flex items-center justify-center mb-4" data-id="element-34">
                {item.icon}
              </div>
              <h3 className="font-serif font-bold text-xl text-[#2D2A26] mb-2" data-id="element-35">
                {item.title}
              </h3>
              <p className="font-sans text-[#2D2A26]/70 leading-relaxed" data-id="element-36">
                {item.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}